import { render, staticRenderFns } from "./WaitingListConfiguration.vue?vue&type=template&id=75decbc2&scoped=true&"
import script from "./WaitingListConfiguration.vue?vue&type=script&lang=js&"
export * from "./WaitingListConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75decbc2",
  null
  
)

export default component.exports